import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input } from '@angular/core';

@Component({
	selector: 'confirm-dialog',
	templateUrl: './confirm-dialog.component.html',
	styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {
	@Input()
	title: string = 'Confirmar';
	@Input()
	confirmText: string = 'Confirmar';
	@Input()
	cancelText: string = 'Fechar';
	@Input()
	neutralText: string = 'Voltar';
	@Input()
	text: string;

	@Input() showCancelButton: boolean = true;
	@Input() showConfirmButton: boolean = true;
	@Input() showNeutralButton: boolean = false;


	constructor(public modal: NgbActiveModal) {
	}
}
